import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../../../services/api';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Textarea } from '../../../components/ui/textarea';
import { Badge } from '../../../components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { useExpenditureLabels, useDecimalFormat } from '../../../contexts/ExpenditureLabelsContext';
import TypeAheadLookup from '../../../components/TypeAheadLookup';
import { LoadingSpinner, EmptyState } from '../../../components/layout/SharedComponents';
import {
  ChevronDown, ChevronLeft, ChevronRight, X, Plus, Trash2,
  Layers, FileText, CheckSquare, Split, Paperclip,
  ScrollText, StickyNote, Package, Activity, Save,
  TrendingUp, BarChart2, Upload, Search, Wand2, Download,
  RefreshCw, Edit, FileSpreadsheet, ListOrdered, AlignJustify, Users
} from 'lucide-react';

export default function IconSidebar({ activePanel, onSelect, counts, tabs, alerts }) {
  return (
    <div className="flex flex-col border-r bg-muted/10 w-10 flex-shrink-0">
      {tabs.map(tab => {
        const count = counts?.[tab.badgeKey] || 0;
        const isActive = activePanel === tab.id;
        const hasAlert = alerts?.[tab.id];
        return (
          <button
            key={tab.id}
            onClick={() => onSelect(tab.id)}
            title={tab.label}
            aria-label={tab.label}
            aria-pressed={isActive}
            className={`relative flex items-center justify-center h-10 w-10 transition-colors border-b ${
              isActive ? 'bg-primary/10 border-l-2 border-l-primary' : 'hover:bg-accent'
            }`}
          >
            <tab.icon className={`h-4 w-4 ${isActive ? 'text-primary' : 'text-muted-foreground'}`} />
            {count > 0 && (
              <span className="absolute top-0.5 right-0.5 min-w-[14px] h-3.5 rounded-full bg-primary text-white text-[9px] flex items-center justify-center px-0.5 leading-none">
                {count}
              </span>
            )}
            {hasAlert && (
              <span className="absolute top-0.5 right-0.5 w-2.5 h-2.5 rounded-full bg-amber-500 border border-white" title="Needs attention" />
            )}
          </button>
        );
      })}
    </div>
  );
}
